import { setupWorker } from "msw/browser";

import { mockHandlerRegistry } from "./registry";

export const worker = setupWorker();

export async function enableMocking(): Promise<void> {
  if (import.meta.env.VITE_MOCK_API !== "true") {
    return;
  }

  const basePath = (import.meta.env.VITE_BASE_URL as string | undefined) || "/";

  // Start worker first with empty handlers
  await worker.start({
    serviceWorker: {
      url: `${basePath}mockServiceWorker.js`,
    },
    onUnhandledRequest: "bypass",
  });

  // Dynamically add handlers from registry as micro-frontends register them
  const handlers = mockHandlerRegistry.getHandlers();
  if (handlers.length > 0) {
    worker.use(...handlers);
  }
}
